import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
  const body = document.body;
  const copySec = document.querySelector(".copy-sec");

  if (!copySec) return;

  ScrollTrigger.create({
    trigger: copySec,
    start: "top 70%",   // rootMargin: -30% とほぼ同じ意味
    end: "bottom top",
    onEnter: () => {
      body.classList.add("is-gradient"); // 下スクロールで入る
    },
    onLeaveBack: () => {
      body.classList.remove("is-gradient"); // 上スクロールで戻る
    },
  });
});
